/**
 * Minimal entry point for static pages that only need navigation.
 */
import { initNavigation } from './navigation.js';

document.addEventListener('DOMContentLoaded', async () => {
  await initNavigation();
});
